import React from "react";
import { TreeView } from "@material-ui/lab";
import { ChevronRight, ExpandMore } from "@material-ui/icons";
import { Directory } from "@interfaces/Directory";
import SelectableDirectoryTreeItem from "./SelectableDirectoryTreeItem";

type Props = {
    root: Directory;
    selectedId: number | null;
    autoOpenIds: Set<number>;
    scrollTargetId: number | null;
    onSelect(chain: Directory[]): void;
};

/** Стабильная ссылка на "нет предков" для корневого узла — свежий [] на
 * каждый рендер сломал бы мемоизацию точно так же, как и для chain внутри
 * самих узлов. */
const NO_ANCESTORS: Directory[] = [];

/** Высота/скролл — забота родителя (FilePickerDialog), а не этого
 * компонента: он просто заполняет контейнер, в котором его разместили. */
const SelectableDirectoryTree = ({
    root,
    selectedId,
    autoOpenIds,
    scrollTargetId,
    onSelect,
}: Props) => {
    return (
        <TreeView
            defaultCollapseIcon={<ExpandMore />}
            defaultExpandIcon={<ChevronRight />}
            defaultExpanded={[root.id, ...autoOpenIds].map(String)}
        >
            <SelectableDirectoryTreeItem
                node={root}
                ancestors={NO_ANCESTORS}
                selectedId={selectedId}
                autoOpenIds={autoOpenIds}
                scrollTargetId={scrollTargetId}
                onSelect={onSelect}
            />
        </TreeView>
    );
};

export default SelectableDirectoryTree;
